// Bitta brauzerda bir vaqtning o'zida faqat BITTA akkaunt ishlashi uchun.
//
// Muammo: token, foydalanuvchi va redux holati localStorage'da saqlanadi, u esa
// brauzerning barcha oynalari (tab) uchun umumiy. Shu sababli ikkinchi oynadan
// boshqa savdo nuqtasi bilan kirilsa, birinchi oyna ham o'sha yangi tokendan
// foydalanib qoladi -- ma'lumotlar aralashib ketadi.
//
// Yechim: har bir login uchun yagona "sessiya kaliti" yaratiladi.
//   localStorage   -- hozirgi (oxirgi kirgan) sessiya kaliti, hamma oynaga umumiy
//   sessionStorage -- shu oynaning kaliti, faqat shu oynaga tegishli
// Kalitlar mos kelmasa, demak boshqa oynadan boshqa akkaunt kirgan -- bu oyna
// tizimdan chiqariladi. Muhimi: bunda umumiy localStorage'ga TEGILMAYDI, aks holda
// endigina kirgan oyna ham tizimdan uchib ketardi.

import { disableStatePersist } from 'store/localStorage'

const SESSION_KEY = 'sessionKey'
const LOGOUT_REASON_KEY = 'logoutReason'

const LOGIN_HASH = '#/auth/login'

function createSessionKey() {
	return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

// Login muvaffaqiyatli bo'lganda chaqiriladi: yangi sessiya boshlanadi va
// boshqa oynalardagi kalitlar eskiradi.
export function startSession() {
	const key = createSessionKey()
	localStorage.setItem(SESSION_KEY, key)
	sessionStorage.setItem(SESSION_KEY, key)
	return key
}

// Oyna ochilganda chaqiriladi. Bir akkauntni bir nechta oynada ochish taqiqlanmagan,
// shuning uchun kaliti yo'q oyna hozirgi sessiyani "o'ziniki" deb oladi.
export function adoptSession() {
	const current = localStorage.getItem(SESSION_KEY)

	if (!current) {
		// Eski (bu funksiya paydo bo'lishidan oldin ochilgan) sessiya -- kalit beramiz.
		if (localStorage.getItem('username')) return startSession()
		return null
	}

	if (!sessionStorage.getItem(SESSION_KEY)) {
		sessionStorage.setItem(SESSION_KEY, current)
	}

	return sessionStorage.getItem(SESSION_KEY)
}

// Shu oyna hozirgi sessiyaga tegishlimi?
export function isSessionValid() {
	const current = localStorage.getItem(SESSION_KEY)
	const mine = sessionStorage.getItem(SESSION_KEY)

	// Kalit hali yo'q bo'lsa tekshirishga asos yo'q -- ishga xalaqit bermaymiz.
	if (!current || !mine) return true

	return current === mine
}

export function getLogoutReason() {
	const reason = sessionStorage.getItem(LOGOUT_REASON_KEY)
	if (reason) sessionStorage.removeItem(LOGOUT_REASON_KEY)
	return reason
}

function isOnLoginPage() {
	return window.location.hash.indexOf('/auth/login') !== -1
}

// authRoutes'dagi mehmon uchun ochiq sahifalar -- ular login talab qilmaydi,
// shu sababli sessiya tekshiruvi ularni tinch qoldirishi kerak.
function isOnPublicPage() {
	const hash = window.location.hash
	return (
		hash.indexOf('/auth/login') !== -1 ||
		hash.indexOf('/forgot-password') !== -1 ||
		hash.indexOf('/cheque/') !== -1 ||
		hash.indexOf('/inventorization') !== -1
	)
}

// Shu oynani tizimdan chiqarish. Umumiy localStorage tozalanmaydi -- u endi
// boshqa (yangi kirgan) akkauntga tegishli. Oynaning eskirgan sessiya kaliti
// ataylab saqlanadi: shu sabab ProtectedRoute uni tizimga qo'ymaydi.
export function forceLogout(reason = 'ANOTHER_LOGIN') {
	if (isOnLoginPage()) return

	// Bu oyna endi holatini saqlamasin -- yangi akkauntning holatini buzmasligi uchun.
	disableStatePersist()

	sessionStorage.setItem(LOGOUT_REASON_KEY, reason)
	window.location.hash = LOGIN_HASH
	window.location.reload()
}

// Boshqa oynadagi login/logout'ni kuzatish. localStorage o'zgarganda `storage`
// hodisasi AYNAN boshqa oynalarda ishga tushadi.
export function watchSession() {
	function check() {
		// Mehmon uchun ochiq sahifalarda (masalan, QR bo'yicha chek ko'rish)
		// sessiya bo'lmasligi tabiiy -- ularni loginga uloqtirmaymiz.
		if (isOnPublicPage()) return
		if (!localStorage.getItem('username')) {
			// Boshqa oynada tizimdan chiqilgan -- umumiy token ham o'chgan.
			forceLogout('LOGGED_OUT')
			return
		}
		if (!isSessionValid()) {
			forceLogout('ANOTHER_LOGIN')
		}
	}

	window.addEventListener('storage', (event) => {
		if (event.key !== SESSION_KEY && event.key !== 'username' && event.key !== null) return
		check()
	})

	// `storage` hodisasi o'tkazib yuborilgan bo'lsa (masalan oyna uxlab qolgan),
	// oynaga qaytilganda ham tekshiramiz.
	window.addEventListener('focus', check)

	check()
}
